import request from '@/utils/request'

const basePath = '/api/training'

/**
 * 根据id查询实训
 * @param id
 */
export function findTrainingById(id) {
    return request({
        url: `${basePath}/com.tipdm:tipdm-race-web:jar:v1.6.6`,
        method: 'get',
    })
}

/**
 * 查询用户正在运行中的实例
 * @param data
 * @returns {*}
 */
export function findInstancesByUser(data) {
    return request({
        url: `${basePath}/instances/users/${data.namespaceMark}`,
        method: 'get',
        params: {
            client_mark: data.clientMark,
            platform_mark: data.platformMark
        }
    })
}

/**
 * 获取镜像列表
 * @param platformMark
 */
export function getMirrorsList(platformMark) {
    return request({
        url: `${basePath}/mirrors`,
        method: 'get',
        params: {
            platformMark: platformMark
        }
    })
}

/**
 * 获取实例列表
 * @param params
 * @returns {*}
 */
export function getInstances(params) {
    return request({
        url: `${basePath}/instances`,
        method: 'get',
        params: params
    })
}

/**
 * 创建实例
 * @param data
 */
export function createInstances(data) {
    return request({
        url: `${basePath}/instances`,
        method: 'post',
        data: data
    })
}

/**
 * 批量创建实例
 * @param id
 * @returns {*}
 */
export function batchCreateInstances(id) {
    return request({
        url: `${basePath}/instances/batches`,
        method: 'post',
        data: {id}
    })
}

/**
 * 停止实例
 * @param id
 * @returns {*}
 */
export function batchStopInstances(id) {
    return request({
        url: `${basePath}/instances/batches`,
        method: 'put',
        data: {id}
    })
}

/**
 * 删除实例
 * @param id
 */
export function deleteInstances(id) {
    return request({
        url: `${basePath}/instances/com.tipdm:tipdm-race-web:jar:v1.6.6`,
        method: 'delete'
    })
}

/**
 * 批量删除实例
 * @param id
 * @returns {*}
 */
export function batchDeleteInstances(id) {
    return request({
        url: `${basePath}/instances/batches`,
        method: 'delete',
        data: {id}
    })
}

/**
 * 获取进入实训链接
 * @param instancesId
 */
export function getTrainingUrl(instancesId) {
    return request({
        url: `${basePath}/instances/${instancesId}/access_address`,
        method: 'get',
    })
}

/**
 * 获取实例文件列表
 * @param instancesId
 */
export function getTrainingFiles(instancesId) {
    return request({
        url: `${basePath}/instances/${instancesId}/files`,
        method: 'get',
    })
}

/**
 * 获取实训实例环境中上传文件的地址、请求头
 * @param instancesId
 * @param data
 */
export function getTrainingUploadFileUrl(instancesId, data) {
    return request({
        url: `${basePath}/instances/${instancesId}/files`,
        method: 'post',
        data: data
    })
}

/**
 * 停止实训
 * @param instancesId
 */
export function stopTraining(instancesId) {
    return request({
        url: `${basePath}/instances/${instancesId}`,
        method: 'put'
    })
}

/**
 * 延时实训
 * @param instancesId
 */
export function delayTraining(instancesId) {
    return request({
        url: `${basePath}/instances/${instancesId}/delay`,
        method: 'post'
    })
}

/**
 * 下载实训实例环境中的文件
 * @param instancesId
 * @param filePath
 */
export function getFileReception(instancesId, filePath) {
    return request({
        url: `${basePath}/instances/${instancesId}/files/receptions`,
        method: 'get',
        params: {
            filePath: filePath
        }
    })
}

/**
 * 获取实例规格信息
 * @param instancesId
 * @returns {*}
 */
export function getInstancesSpecification(instancesId) {
    return request({
        url: `${basePath}/instances/${instancesId}/specification`,
        method: 'get'
    })
}

/**
 * 执行批阅脚本
 * @param instancesId
 * @param data
 * @returns {*}
 */
export function executeCommand(instancesId, data) {
    return request({
        url: `/api/exam/training/instance/${instancesId}/script/review`,
        method: 'post',
        data: data
    })
}

/**
 * 获取上次提交时间
 * @param instancesId
 * @param data
 * @returns {*}
 */
export function getLastDate(instancesId, params) {
    return request({
        url: `/api/exam/training/instance/${instancesId}/date`,
        method: 'get',
        params: params
    })
}

/**
 * 获取操作历史
 * @param instancesId
 * @param data
 * @returns {AxiosPromise}
 */
export function getOperateHistory(answerSheetId, questionId) {
    return request({
        url: `/api/exam/training/instance/history/${answerSheetId}/${questionId}`,
        method: 'get'
    })
}

/**
 * 收集操作历史
 * @param instancesId
 * @param data
 * @returns {AxiosPromise}
 */
export function postOperateHistory(data) {
    return request({
        url: `${basePath}/instances/${data.id}/operate_history`,
        method: 'post',
        data: JSON.stringify(data)
    })
}

